import { stellateQuery } from '@/helpers/graphql_modules/stellate';
import { Lesson } from '@/models/pegasus-epona/lesson.model';
import { getLessonBySlug } from '@/store/queries/stellate.queries';

export class StellateLessonsReaderService {
  public static async getLessonBySlug(lessonSlug: string): Promise<Lesson> {
    const {
      data: { faculLesson },
    } = await stellateQuery(
      getLessonBySlug,
      { slug: lessonSlug },
      {
        'ignore-cache': true,
      },
    );

    return faculLesson;
  }
}
